export default "__VITE_ASSET__mff8Qv2n__"